import {
  FileText,
  FileImage,
  FileSpreadsheet,
  FileArchive,
  FileVideo,
  FileAudio,
  FileCode,
  File as FileGeneric,
} from "lucide-react";

// Map extension -> { Icon, label, accent (tailwind text class), tint (bg class) }
const MAP = {
  pdf: {
    Icon: FileText,
    label: "PDF",
    accent: "text-rose-600",
    tint: "bg-rose-50",
  },
  doc: { Icon: FileText, label: "Word", accent: "text-blue-700", tint: "bg-blue-50" },
  docx: {
    Icon: FileText,
    label: "Word",
    accent: "text-blue-700",
    tint: "bg-blue-50",
  },
  txt: {
    Icon: FileText,
    label: "Text",
    accent: "text-zinc-600",
    tint: "bg-zinc-100",
  },
  xls: {
    Icon: FileSpreadsheet,
    label: "Excel",
    accent: "text-emerald-700",
    tint: "bg-emerald-50",
  },
  xlsx: {
    Icon: FileSpreadsheet,
    label: "Excel",
    accent: "text-emerald-700",
    tint: "bg-emerald-50",
  },
  csv: {
    Icon: FileSpreadsheet,
    label: "CSV",
    accent: "text-emerald-700",
    tint: "bg-emerald-50",
  },
  ppt: {
    Icon: FileText,
    label: "PowerPoint",
    accent: "text-orange-600",
    tint: "bg-orange-50",
  },
  pptx: {
    Icon: FileText,
    label: "PowerPoint",
    accent: "text-orange-600",
    tint: "bg-orange-50",
  },
  png: {
    Icon: FileImage,
    label: "PNG",
    accent: "text-violet-600",
    tint: "bg-violet-50",
  },
  jpg: {
    Icon: FileImage,
    label: "JPG",
    accent: "text-violet-600",
    tint: "bg-violet-50",
  },
  jpeg: {
    Icon: FileImage,
    label: "JPEG",
    accent: "text-violet-600",
    tint: "bg-violet-50",
  },
  webp: {
    Icon: FileImage,
    label: "WEBP",
    accent: "text-violet-600",
    tint: "bg-violet-50",
  },
  gif: {
    Icon: FileImage,
    label: "GIF",
    accent: "text-violet-600",
    tint: "bg-violet-50",
  },
  svg: {
    Icon: FileImage,
    label: "SVG",
    accent: "text-violet-600",
    tint: "bg-violet-50",
  },
  zip: {
    Icon: FileArchive,
    label: "ZIP",
    accent: "text-amber-700",
    tint: "bg-amber-50",
  },
  rar: {
    Icon: FileArchive,
    label: "RAR",
    accent: "text-amber-700",
    tint: "bg-amber-50",
  },
  "7z": {
    Icon: FileArchive,
    label: "7Z",
    accent: "text-amber-700",
    tint: "bg-amber-50",
  },
  mp4: {
    Icon: FileVideo,
    label: "MP4",
    accent: "text-fuchsia-700",
    tint: "bg-fuchsia-50",
  },
  mov: {
    Icon: FileVideo,
    label: "MOV",
    accent: "text-fuchsia-700",
    tint: "bg-fuchsia-50",
  },
  mp3: {
    Icon: FileAudio,
    label: "MP3",
    accent: "text-cyan-700",
    tint: "bg-cyan-50",
  },
  wav: {
    Icon: FileAudio,
    label: "WAV",
    accent: "text-cyan-700",
    tint: "bg-cyan-50",
  },
  json: {
    Icon: FileCode,
    label: "JSON",
    accent: "text-slate-700",
    tint: "bg-slate-100",
  },
  js: {
    Icon: FileCode,
    label: "JS",
    accent: "text-slate-700",
    tint: "bg-slate-100",
  },
};

export function getFileMeta(extension = "") {
  const key = String(extension).toLowerCase();
  return (
    MAP[key] || {
      Icon: FileGeneric,
      label: key ? key.toUpperCase() : "FILE",
      accent: "text-zinc-600",
      tint: "bg-zinc-100",
    }
  );
}

// Human readable file size
export function formatBytes(bytes) {
  if (!bytes && bytes !== 0) return "—";
  if (bytes === 0) return "0 B";
  const units = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const value = bytes / Math.pow(1024, i);
  return `${value.toFixed(value >= 10 || i === 0 ? 0 : 1)} ${units[i]}`;
}

// Sum bytes
export function totalSize(files = []) {
  return files.reduce((sum, f) => sum + (f.sizeBytes || 0), 0);
}
